import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20artistic%20background%20with%20flowing%20organic%20gradient%20shapes%20in%20amber%20coral%20and%20cream%20tones%2C%20soft%20dreamy%20cinematic%20light%20leaks%2C%20ethereal%20texture%20with%20subtle%20lens%20flare%20effects%2C%20modern%20creative%20broadcast%20design%2C%20elegant%20minimalist%20composition%2C%20warm%20atmospheric%20glow%2C%20professional%20film%20production%20aesthetic%2C%20gentle%20bokeh%20circles%2C%20flowing%20silk%20texture&width=1600&height=900&seq=hero-video-platform&orientation=landscape"
          alt="国产自拍视频精选合集"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/45 via-foreground-900/25 to-foreground-900/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-6">
          真实记录生活每一刻
        </span>
        <h1 className="text-3xl md:text-5xl font-heading text-background-50 leading-tight mb-6">
          国产自拍视频精选合集
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          探索最热门的国产自拍视频内容，涵盖生活记录、旅行vlog、美食探店、创意短片等多元题材。发现真实、有趣、有温度的本土原创视频。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/life-record"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即浏览精选
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 text-background-50 backdrop-blur-sm rounded-full text-sm font-semibold hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-8 text-background-200/80 text-sm">
          <div className="text-center">
            <div className="text-xl font-bold text-background-50">10万+</div>
            <div className="text-xs">精选视频</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-xl font-bold text-background-50">5000+</div>
            <div className="text-xs">原创作者</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-xl font-bold text-background-50">8大</div>
            <div className="text-xs">内容分类</div>
          </div>
        </div>
      </div>
    </section>
  );
}